import config from 'config/config'
import { classNames } from 'lib/utilities'
import React from 'react'
import { connect } from 'react-redux'
import { Segment, Table } from 'semantic-ui-react'
import AttachedMediaListItem from './AttachedMediaListItem'

const mapStateToProps = (state, ownProps) => {
  const { media } = state.media
  const mediaList =
    media.length > 0
      ? ownProps.mediaIdList.map((mediumId) =>
          media.find((medium) => medium.id === mediumId)
        )
      : []
  return { mediaList }
}

const mapDispatchToProps = (dispatch) => {
  return {}
}

class AttachedMediaList extends React.Component {
  state = {
    dragMarker: {},
  }

  findMedium(dragId) {
    const { mediaList } = this.props
    const item = mediaList.find((medium) => medium.id === dragId)
    return {
      item,
      index: mediaList.indexOf(item),
    }
  }

  getMedia() {
    const { dragMarker = {} } = this.state
    const { mediaList } = this.props
    const { deleteMedium, moveMedium } = this.props
    return mediaList.map((medium, index) => (
      <AttachedMediaListItem
        {...{
          key: index,
          index: index,
          dragId: medium.id, // TODO: Check if we want to use a special drag id here, because of duplicate entries
          medium: medium,
          deleteMedium: deleteMedium,
          findItem: (dragId) => this.findMedium(dragId),
          moveItem: moveMedium,
          setDragMarker: (dragMarker) => this.setState({ dragMarker }),
          dragMarker: dragMarker,
        }}
      />
    ))
  }

  render() {
    const dark = config.theme.dark

    return (
      <Segment attached className={classNames(['payload', dark && 'inverted'])}>
        <Table
          sortable
          compact
          size="small"
          basic="very"
          className="spaced mediaList">
          <Table.Body children={this.getMedia()} />
        </Table>
      </Segment>
    )
  }
}

AttachedMediaList = connect(mapStateToProps, mapDispatchToProps)(
  AttachedMediaList
)
export default AttachedMediaList



// WEBPACK FOOTER //
// ./src/components/shared/MediaBrowser/AttachedMediaList.jsx